import Fuse from 'fuse.js';
import markdownIt from 'markdown-it';

const md = new markdownIt();
let fuse = null;

export async function loadMarkdownFiles() {
  try {
    const response = await fetch('/md/linux-commands/index.json');
    if (!response.ok) {
      throw new Error('Failed to load index.json');
    }
    const files = await response.json();

    // Convert markdown content to HTML
    files.forEach(file => {
      file.htmlContent = md.render(file.content);
    });

    fuse = new Fuse(files, {
      keys: ['fileName', 'content'],
      includeScore: true
    });
  } catch (error) {
    console.error('Error loading markdown files:', error);
  }
}

export function search(query) {
  if (!fuse) {
    throw new Error('Fuse.js instance is not initialized. Call loadMarkdownFiles first.');
  }

  return fuse.search(query).map(result => result.item);
}
